/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { CustomerIndustryMasterApi } from "@/apis/clients";
import { wrap } from "@/apis/wrap";

export const customerIndustryMasterApi = {
  getCustomerIndustries: wrap(
    CustomerIndustryMasterApi,
    CustomerIndustryMasterApi.prototype.getCustomerIndustries,
  ),
};
